import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { SubscriptionProvider } from "./contexts/SubscriptionContext";
import AnalyticsBridge from "./analytics/AnalyticsBridge";
import { captureDiscountFromUrl } from "./utils/pendingDiscount";
import { captureCampaignFromUrl } from "./utils/campaign";

// A shared …/pricing?code=X (or /?code=X) link: keep the code before any
// redirect can drop the query string.
const DiscountCapture = () => {
  const { pathname, search } = useLocation();
  useEffect(() => {
    captureDiscountFromUrl(pathname, search);
  }, [pathname, search]);
  return null;
};

// A campaign link given as a final URL (…/pricing?c=<slug>): count it, once
// per page load, without leaving the page. /go/<slug> counts its own.
const CampaignCapture = () => {
  const { pathname, search } = useLocation();
  useEffect(() => {
    captureCampaignFromUrl(pathname, search);
  }, [pathname, search]);
  return null;
};

// Pathless layout route: provides auth + subscription context to the whole app.
// Must live INSIDE the router tree because AuthProvider uses useNavigate.
// AnalyticsBridge sits here too — it needs the router (screen_viewed) and both
// contexts (user id + tier user properties).
const AppProviders = () => (
  <AuthProvider>
    <SubscriptionProvider>
      <AnalyticsBridge />
      <DiscountCapture />
      <CampaignCapture />
      <Outlet />
    </SubscriptionProvider>
  </AuthProvider>
);

export default AppProviders;
